import { render, staticRenderFns } from "./BoxActive.vue?vue&type=template&id=070377a8&"
import script from "./BoxActive.vue?vue&type=script&lang=ts&"
export * from "./BoxActive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports